import styled from "styled-components";

const StatsBox = styled.div`
  background: white;
  width: 100%;
  margin-bottom: auto;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  border-radius: 0.5em;
`;

const Stat = styled.div`
  display: flex;
  padding: 0.5em 1.5em;
  align-items: center;

  img {
    width: 10%;
    max-width: 4em;
    margin-right: 1em;

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      width: 12.5%;
    }
  }

  p {
    color: #673c8c;
    font-size: 2em;
    font-weight: bold;

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      font-size: 1.25em;
    }
  }

  span {
    margin-left: auto;
    padding: 0.5em 1em;
    background: #673c8c;
    color: #fff;
    font-weight: bold;
    font-size: 1.5em;
    border-radius: 5%;
    min-width: 35px;
    text-align: center;

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      font-size: 1.25em;
    }
  }
`;

export { StatsBox, Stat };
